import React from "react";
import { Select } from "antd";

interface LayersInputProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
}

const layerOptions = [
    {
        label: "Layer 1: Default view",
        value: "default_view",
    },
    {
        label: "Layer 2: App comparison view",
        value: "app_comparison_view",
    },
    {
        label: "Layer 3: Persistent change view",
        value: "persistent_change_view",
    },
    {
        label: "Layer 4: Increase change point view",
        value: "increase_change_point_view",
    },
    {
        label: "Layer 5: Ad Ops change point view",
        value: "ad_ops_change_point_view",
    },
];

export const LayersInput: React.FC<LayersInputProps> = ({ value, onChange, placeholder = "Select layer", style }) => {
    return (
        <Select
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            options={layerOptions}
            style={{ width: 250, ...style }}
            allowClear
        />
    );
};
